/**
 * @generated SignedSource<<91eb2a3d04e52917a45ca405de73e8cd>>
 * @relayHash 0d7cc146aa12b13eaa5a11bd667fa49c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraVersionDetailsCollapsedUi = "DESCRIPTION" | "ISSUES" | "ISSUE_ASSOCIATED_DESIGNS" | "PROGRESS_CARD" | "RELATED_WORK" | "RICH_TEXT_SECTION" | "RIGHT_SIDEBAR" | "%future added value";
export type JiraVersionDetailsCollapsedUisInput = {
  collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi>;
  versionId: string;
};
export type ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$variables = {
  input: JiraVersionDetailsCollapsedUisInput;
};
export type ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$data = {
  readonly jira: {
    readonly saveVersionDetailsCollapsedUis: {
      readonly success: boolean;
      readonly version: {
        readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$rawResponse = {
  readonly jira: {
    readonly saveVersionDetailsCollapsedUis: {
      readonly success: boolean;
      readonly version: {
        readonly collapsedUis: ReadonlyArray<JiraVersionDetailsCollapsedUi | null | undefined> | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ui_collapsibleUiTriggerButton_updateCollapsedUisMutation = {
  rawResponse: ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$rawResponse;
  response: ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$data;
  variables: ui_collapsibleUiTriggerButton_updateCollapsedUisMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "collapsedUis"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
            "kind": "LinkedField",
            "name": "saveVersionDetailsCollapsedUis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraVersionDetailsCollapsedUisPayload",
            "kind": "LinkedField",
            "name": "saveVersionDetailsCollapsedUis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "59da25bc507c60457c7c0a7f80672b6888c11c77e2bed2a33db2c0d2dcd80db9",
    "metadata": {},
    "name": "ui_collapsibleUiTriggerButton_updateCollapsedUisMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "784b6375f621589ebabb1f85323c82aa";

export default node;
